import type { AxiosRequestConfigExtended } from '@vision/ui/interfaces';
import type { PlannerTaskRelationCreateArgs, PlannerTaskRelationDeleteArgs } from './task-relations.api.types';
import { createHttpExtraOptions } from '@vision/ui/utils';

export const buildCreateTaskRelationRequest = ({
  plannerId,
  accountId,
  dashboardId,
  taskId,
  data,
}: PlannerTaskRelationCreateArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/task_relations`,
  method: 'POST',
  params: {
    account_id: accountId,
    dashboard_id: dashboardId,
    task_id: taskId,
  },
  data,
  headers: {
    'Content-Type': 'application/json',
  },
  extraOptions: createHttpExtraOptions({
    notification: {
      autoHandleError: false,
      autoHandleSuccess: false,
    },
  }),
});

export const buildDeleteTaskRelationRequest = ({
  plannerId,
  accountId,
  dashboardId,
  taskId,
  taskRelationId,
}: PlannerTaskRelationDeleteArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/task_relations/${taskRelationId}/delete`,
  method: 'POST',
  params: {
    account_id: accountId,
    dashboard_id: dashboardId,
    task_id: taskId,
  },
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.deleteTaskRelation.{{status}}',
      autoHandleSuccess: false,
    },
  }),
});
